import { createContext } from "react";
import { FormField } from "@jugl-web/rest-api";

export type SortStateType = {
  sortBy:
    | {
        id: string;
        type: FormField["type"];
      }
    | undefined;
  sortOrder: "asc" | "desc" | null;
};

export interface CustomersContextValue {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  queryFilters: string[];
  setQueryFilters: (filters: string[]) => void;
  sortState: SortStateType;
  setSortState: (sortState: SortStateType) => void;
  transformedSearchBy?:
    | { id: string; values: FormField["values"] }[]
    | undefined;
}

export const CustomersContext = createContext<CustomersContextValue | null>(
  null
);
